/**
 * Pages that may leave Classic when enable_modern_ui_by_default is on.
 * Dashboard, login, and any page missing from these lists stay in the classic folder.
 * Report and settings lists match the classic apps so a missing modern route is not opened.
 */
const AMC_ROUTE_PREFIXES = [
  '/amc-master',
  '/amc-department',
  '/amc-template',
  '/amc-unassigned-tasks',
  '/amc-job-card',
  '/my-amc-task',
  '/task-approvals',
  '/all-amc-tasks',
  '/amc-task-reassign-inactivate',
  '/amc-renewal-dashboard',
  '/amc-approval',
  '/amc-vendor',
  '/my-mis-score',
  '/company-level-mis-score',
];

const REPORTS_HUB_ROUTE_PREFIXES = [
  '/account-master-report',
  '/costcenter-report',
  '/department-report',
  '/employee-report',
  '/grn-report',
  '/grn-batch-report',
  '/rejected-goods-report',
  '/invoice-payment-report',
  '/irn-report',
  '/invoice-report',
  '/allocation-report',
  '/allocation-line-item-report',
  '/pr-report',
  '/pr-report-v2',
  '/aging-report',
  '/ageing-report-v2',
  '/gst-report',
  '/gst1-report',
  '/product-report',
  '/dimension1-report',
  '/crash-report',
  '/tds-payment-report',
  '/tds-report',
  '/vendor-report',
  '/po-report',
  '/amc-report',
  '/all-task-report',
  '/set-budget-report',
  '/customer-report',
  '/warranty-installation-report',
  '/tds-return-report',
  '/trail-balance-dimenson-wise',
  '/trial-balance-cost-centre-wise',
  '/trial-balance-lob-wise',
  '/summarized-po-report',
  '/trial-balance-customer-wise',
  '/custom-group-report',
  '/custom-group-tree-report',
  '/tax-depreciation-report',
  '/current-year-assets-purchase-report',
  '/sales-invoice-report',
  '/sales-report',
  '/sales-invoice-product-wise-report',
  '/recurring-invoice-report',
  '/gross-margin-report',
  '/costcenter-level-bl-report',
  '/costcenter-level-pl-report',
  '/trial-balance-vendor-wise',
  '/product-expiry',
  '/stock-issue',
  '/po-report-product-wise',
  '/po-pending-report',
  '/physical-verification',
  '/vendor-balance',
  '/customer-balance',
  '/customer-balance-approval',
  '/customer-balance-summary',
  '/my-customer-balance',
  '/all-customer-balance',
  '/product-reorder-report',
  '/product-reorder-costcenter-level',
  '/product-reorder-location-wise',
  '/product-wise-invoice-report',
  '/grir-account-report',
  '/retention-account-report',
  '/vendor-balance-summary-report',
  '/customer-balance-summary-report',
  '/project-report',
  '/my-project-report',
  '/zoho-logs',
  '/ms-sql-logs',
  '/my-project-revenue-report',
  '/all-project-revenue-report',
  '/customer-balance-detail',
  '/project-report-tree-view',
  '/custom-group-org-chart-report',
  '/open-pr-quantity-report',
  '/time-sheet-report',
  '/expense-sheet-report',
  '/combine-ledger-report',
  '/po-rejection-summary-report',
  '/quality-rejection-report',
  '/pr-rejection-summary',
  '/approved-invoice-report',
  '/open-po-report',
  '/invoice-pending-for-approval',
  '/open-po-report-v2',
  '/vendor-master-report',
  '/pending-po-for-approval',
  '/employee-activity',
  '/vendor-activity',
  '/prepared-equalization-levy',
  '/compliance-detailed-report',
  '/pr-average-approval-time-report',
  '/po-average-approval-time-report',
  '/invoice-average-approval-time-report',
  '/advance-payment-party-wise',
  '/pl-report-lob-level',
  '/bs-report-lob-level',
  '/sales-order-product-wise-report',
  '/capital-report',
  '/p2p-avg-report',
  '/Stn-to-vendor-report',
  '/chargeable-weight-vendor-level-report',
  '/goods-deviation-report',
  '/material-planning-report',
  '/bom-report',
  '/invoice-average-price-report',
  '/sales-return-report',
  '/pr-average-report-costcentrewise',
  '/po-average-report-costcentrewise',
  '/invoice-average-report-costcentrewise',
  '/irn-average-report-costcentrewise',
  '/grn-average-report-costcentrewise',
  '/payment-average-report-costcentrewise',
  '/invoice-payment-report-v2',
  '/shipment-pending-report',
  '/open-pr-qty-report-v2',
  '/gst-input-report',
  '/daily-production-report',
  '/running-production-report',
  '/sales-order-level-report',
  '/stn-report',
  '/returnable-gate-pass-report',
  '/budget-report',
  '/budget-report-group-level',
  '/cost-center-level-budget-report',
  '/budget-report-based-on-cost-center-v2',
  '/project-level-budget-report',
  '/credit-note-report',
  '/vendor-spend-analysis',
  '/detailed-expense-sheet-report',
  '/rfq-report',
  '/approve-rfq-report',
  '/email-logs',
  '/background-processes',
  '/download-bulk-data',
  '/gstr-2b-report',
  '/global-imports',
  '/pr-wise-report',
  '/production-batch-report',
  '/po-advance-payment-report',
  '/ap-ageing-report',
  '/blanket-po-report',
  '/pr-tat-report',
  '/customer-balance-summary-report-v2',
  '/customer-ageing-report',
  '/dc-level-report',
  '/dc-note-productwise-report',
  '/ir-wise-report',
  '/ir-item-level-report',
  '/procure-to-pay-report',
  '/batch-wise-available-qty-report',
  '/period-based-budget-report',
  '/pr-ageing-report',
  '/sales-order-status-report',
  '/invoice-status-report',
  '/grn-status-report',
  '/payment-status-report',
  '/po-status-report',
  '/pr-status-report',
  '/irn-status-report',
];

const SETTINGS_V2_ROUTE_PREFIXES = [
  '/dashboard',
  '/my-profile',
  '/reset-password',
  '/reset-book-password',
  '/adduser-role',
  '/add-vendoruser-role',
  '/user-role-approval',
  '/vendoruser-role-approval',
  '/smtp-configuration',
  '/bank-cred',
  '/imap-configuration',
  '/replication-logs',
  '/netsuite-credentials',
  '/sap-credentials',
  '/Company-Setup',
  '/setup-for-company-admin',
  '/company-setup-v2',
  '/general-settings',
  '/report-settings',
  '/mpr-settings',
  '/si-settings',
  '/irn-settings',
  '/grn-settings',
  '/po-settings',
  '/invoice-settings',
  '/recurring-invoice-settings',
  '/employee-master-settings',
  '/vendor-master-settings',
  '/project-master-settings',
  '/mapping-settings',
  '/account-settings',
  '/depreciation-settings',
  '/vendor-management-settings',
  '/task-master-tab',
  '/amc-master-tab',
  '/inventory-register-tab',
  '/inventory-request-tab',
  '/asset-management-settings',
  '/clppd-settings',
  '/my-advance-settings',
  '/expense-sheet-settings',
  '/journal-settings',
  '/master-column-settings',
  '/restrict-for-je-settings',
  '/proforma-invoice-settings',
  '/production-settings',
  '/android-column-settings',
  '/client-master-settings',
  '/project-management-settings',
  '/invoice-payments-settings',
  '/quotation-management-settings',
  '/pr-settings',
  '/dashboard-settings',
  '/compliance-management-settings',
  '/e-invoice-credential-console',
  '/e-way-credential-console',
  '/my-setup-v2',
  '/sales-invoice-settings',
  '/pick-pack-settings',
  '/sales-order-settings',
  '/tally-integration-setup',
  '/qbsettings',
  '/budget-management',
  '/gst-integration',
  '/fetch-gstr-data',
  '/prediction-models-training',
  '/zero-touch-companies',
  '/company-setup-replication',
  '/srn-tab',
  '/gate-pass-settings',
  '/zoho-reporting-tag',
  '/s3-configuration',
  '/configure-gst-credential',
];

const CLASSIC_ONLY_PREFIXES = ['/login', '/my-companies', '/login-v2'];

function normalizeLogicalPath(path: string): string {
  var raw = String(path == null ? '' : path).split('?')[0];
  var hashAt = raw.indexOf('#');
  if (hashAt >= 0) {
    raw = raw.slice(hashAt + 1);
  }
  raw = raw.replace(/^\s+|\s+$/g, '');
  if (!raw) {
    raw = '/';
  }
  if (raw.charAt(0) !== '/') {
    raw = '/' + raw;
  }
  if (raw.length > 1 && raw.charAt(raw.length - 1) === '/') {
    raw = raw.slice(0, -1);
  }
  return raw || '/';
}

function matchesPrefix(logical: string, prefixes: string[]): boolean {
  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    if (logical === prefix || logical.indexOf(prefix + '/') === 0) {
      return true;
    }
  }
  return false;
}

function isClassicOnlyPath(logical: string): boolean {
  if (logical === '/' || logical === '/dashboard') {
    return true;
  }
  return matchesPrefix(logical, CLASSIC_ONLY_PREFIXES);
}

function shellForProject(project: string, logical: string): string {
  var key = String(project == null ? '' : project).replace(/^\s+|\s+$/g, '').toLowerCase();
  if (key === 'master' || key === 'masterprime') {
    return matchesPrefix(logical, AMC_ROUTE_PREFIXES) ? 'masterprime' : '';
  }
  if (key === 'reports' || key === 'reports-hub' || key === 'report') {
    return matchesPrefix(logical, REPORTS_HUB_ROUTE_PREFIXES) ? 'reports-hub' : '';
  }
  if (key === 'settings' || key === 'settings-v2') {
    if (logical === '/dashboard') {
      return '';
    }
    return matchesPrefix(logical, SETTINGS_V2_ROUTE_PREFIXES) ? 'settings-v2' : '';
  }
  return '';
}

/** True when this menu page has a modern shell. Dashboard and unknown pages are false. */
export function isSiblingModernCandidate(project: string, path: string): boolean {
  var raw = String(path == null ? '' : path);
  var logical = normalizeLogicalPath(raw);
  if (isClassicOnlyPath(logical)) {
    return false;
  }
  return shellForProject(project, logical) !== '';
}

function prefersSiblingModern(): boolean {
  if (typeof localStorage === 'undefined') {
    return false;
  }
  var choice = localStorage.getItem('intelaccounts_ui_mode_user_choice');
  var storedChoice = String(choice != null ? choice : '').toLowerCase();
  if (storedChoice === 'classic') {
    return false;
  }
  if (storedChoice === 'modern') {
    return true;
  }
  return localStorage.getItem('intelaccounts_enable_modern_ui_by_default') === '1';
}

function watchKeyForFolder(folder: string): string {
  if (folder === 'settings-v2') {
    return 'intelaccounts_modern_opened_in_tab';
  }
  return 'intelaccounts_modern_shell_exit_watch';
}

/**
 * Open origin/<modern-folder>/#/<page> when the company flag or a Modern click says so.
 * Returns false when the page must stay on its classic URL.
 */
export function openSiblingModernShell(project: string, path: string): boolean {
  if (!prefersSiblingModern() || typeof window === 'undefined') {
    return false;
  }
  var raw = String(path == null ? '' : path);
  var qIndex = raw.indexOf('?');
  var qs = qIndex >= 0 ? raw.slice(qIndex) : '';
  var logical = normalizeLogicalPath(raw);
  var folder = shellForProject(project, logical);
  if (!folder || isClassicOnlyPath(logical)) {
    return false;
  }
  var hashSeg = logical.replace(/^\//, '');
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('intelaccounts_ui_mode', 'modern');
    localStorage.setItem('intelaccounts_modern_session_refresh_pending', '1');
  }
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(watchKeyForFolder(folder), '1');
  }
  window.location.href = window.location.origin + '/' + folder + '/#/' + hashSeg + qs;
  return true;
}



// WEBPACK FOOTER //
// /codebuild/output/src1914368402/src/src/app/shared/utils/sibling-modern-shell.ts